import { render, staticRenderFns } from "./OtpCredential.vue?vue&type=template&id=b3a483f2&"
import script from "./OtpCredential.vue?vue&type=script&lang=js&"
export * from "./OtpCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports